import React from 'react';
import Lottie from  "lottie-react";
import SpaceBoy from "../LottieFiles/SpaceBoy.json";
import Typed from "./Typed.js";
import Tilt from 'react-parallax-tilt';
import Avatar from '../images/Avatar.png';
import {FaLaptopCode} from "react-icons/fa";

const Home = () => {
  return (
    <div >
      <div className='HomePage'>

        <div className='HomeText'>
          <h1>Hi there!</h1>
          <h1>I'm <b>PRADEEPIKA NORI</b></h1>
          <Typed/>   
        </div>

        <Lottie 
          className="illustration" 
          animationData={SpaceBoy} 
          loop={true} 
        />
        
      </div>

      <div className='AboutPage'>
        <div className='AboutText'>
          <h1 className='AboutTextHeading'>Brief <b>introduction</b></h1>
          <p>
            I enjoy turning raw ideas into real, meaningful products. I look for work that challenges me, helps me grow as an engineer, and makes me proud of what I create.<br /><br />
            I am fluent in <b>C++</b> and <b>Python</b> with a keen interest in <b>software development</b> and in creating <b>AI-driven applications</b>. I am actively exploring projects in the <b>MERN</b> stack and plan to expand my skills by learning <b>Next.js</b>, <b>Three.js</b> and<b> Typescript</b> in the near future. <br /><br />
            I love working on ideas that mix creativity with logical problem-solving—anything from encrypted systems to interactive web apps. Also, I love <b>code, chaos & creativity</b> <FaLaptopCode style={{scale:"1", rotate:"10deg"}}/>   
          </p>
        </div>
        <Tilt>
          <img className='Avatar' src={Avatar} alt="" />
        </Tilt>
      </div>
    </div>
  )
}

export default Home